import { IconPlus, IconTrash } from '@tabler/icons-react';
import { Button, Group, Modal, Select } from '@mantine/core';
import { useProposal } from '../../context/ProposalContext';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Currency, FeeOption, HourlyRate, LumpSum, Retainer, Text } from '@/interfaces/fees';
import { FEE_ACTIONS } from '../../reducers/feeReducer';
import { v4 as uuidv4 } from 'uuid';
import { defaultHourlyRates } from '../../reducers/feeReducer';

export default function AddFee() {
  const [opened, { open, close }] = useDisclosure();
  const { t } = useTranslation();
  const { proposal, dispatchProposal } = useProposal();
  const [feeType, setFeeType] = useState<FeeOption>('LumpSum');
  const [currency, setCurrency] = useState<Currency>('EUR');

  // Handle Add Fee
  const handleAddFee = (e: React.FormEvent) => {
    e.preventDefault();

    let newFee: HourlyRate | LumpSum | Retainer | Text;

    switch (feeType) {
      case 'HourlyRate':
        newFee = {
          type: 'HourlyRate',
          id: uuidv4(),
          currency,
          table: defaultHourlyRates,
          blendedRate: null,
        };
        break;
      case 'LumpSum':
        newFee = {
          type: 'LumpSum',
          id: uuidv4(),
          currency,
          table: [],
          lumpSumType: 'directCharge',
        };
        break;
      //   case 'BlendedRate':
      //     newFee = {
      //       type: 'BlendedRate',
      //       id: uuidv4(),
      //       currency,
      //       rate: 0,
      //     };
      //     break;
      case 'Retainer':
        newFee = {
          type: 'Retainer',
          id: uuidv4(),
          currency,
          amount: 0,
          period: 'Monthly',
        };
        break;
      case 'Text':
        newFee = {
          type: 'Text',
          id: uuidv4(),
          title: '',
          text: '',
        };
        break;
      default:
        return;
    }

    dispatchProposal({
      type: FEE_ACTIONS.ADD_FEE,
      payload: newFee,
    });

    close();
  };

  const feeOptions: { label: string; value: FeeOption }[] = [
    { label: t('lumpSum'), value: 'LumpSum' },
    { label: t('retainer'), value: 'Retainer' },
    { label: t('hourlyRate'), value: 'HourlyRate' },
    { label: t('text'), value: 'Text' },
  ];

  const currencies: Currency[] = ['USD', 'EUR', 'GBP', 'PLN'];

  return (
    <>
      <Button size="sm" variant="light" leftSection={<IconPlus size={18} />} onClick={open}>
        {t('addFee')}
      </Button>

      <Modal opened={opened} onClose={close} title={t('addFee')}>
        <form onSubmit={handleAddFee}>
          <Group>
            <Select
              data={feeOptions}
              value={feeType}
              onChange={(value) => setFeeType(value as FeeOption)}
              required
              allowDeselect={true}
              defaultValue={null}
            />
            <Select
              label={t('currency')}
              data={currencies}
              value={currency}
              onChange={(value) => setCurrency(value as Currency)}
              allowDeselect={true}
              required
              defaultValue={null}
            />
          </Group>
          <Group justify="flex-end" mt="md">
            <Button color="gray" onClick={close}>
              {t('cancel')}
            </Button>
            <Button type="submit">{t('confirm')}</Button>
          </Group>
        </form>
      </Modal>
    </>
  );
}
